export class ApiError extends Error {
  constructor(message, status, details) {
    super(message)
    this.name = 'ApiError'
    this.status = status
    this.details = details
  }
}

async function request(path, options = {}) {
  const response = await fetch(path, {
    credentials: 'same-origin',
    headers: {
      Accept: 'application/json',
      ...(options.body ? { 'Content-Type': 'application/json' } : {}),
      ...options.headers,
    },
    ...options,
  })

  const data = await response.json().catch(() => null)
  if (!response.ok) {
    throw new ApiError(
      data?.error || data?.message || 'Une erreur est survenue. Réessayez dans un instant.',
      response.status,
      data,
    )
  }
  return data
}

export const api = {
  saveProfile: (nickname) =>
    request('/api/profile', { method: 'POST', body: JSON.stringify({ nickname }) }),
  startDaily: (nickname) =>
    request('/api/daily/start', { method: 'POST', body: JSON.stringify({ nickname }) }),
  submitDaily: (board, day) =>
    request('/api/daily/submit', { method: 'POST', body: JSON.stringify({ board, day }) }),
  pauseDaily: (day) =>
    request('/api/daily/pause', { method: 'POST', body: JSON.stringify({ day }) }),
  resumeDaily: (day) =>
    request('/api/daily/resume', { method: 'POST', body: JSON.stringify({ day }) }),
  leaderboard: (limit = 50, day = null) => {
    const query = new URLSearchParams({ limit: String(limit) })
    if (day) query.set('day', day)
    return request(`/api/daily/leaderboard?${query}`)
  },
  training: (difficulty) => request(`/api/training?difficulty=${encodeURIComponent(difficulty)}`),
  archiveDays: ({ before = null, limit = 31 } = {}) => {
    const query = new URLSearchParams({ limit: String(limit) })
    if (before) query.set('before', before)
    return request(`/api/archives?${query}`)
  },
  startArchive: (day) => request('/api/archives/start', {
    method: 'POST',
    body: JSON.stringify({ day }),
  }),
  pauseArchive: (day) => request('/api/archives/pause', {
    method: 'POST',
    body: JSON.stringify({ day }),
  }),
  resumeArchive: (day) => request('/api/archives/resume', {
    method: 'POST',
    body: JSON.stringify({ day }),
  }),
  submitArchive: (day, board) => request('/api/archives/submit', {
    method: 'POST',
    body: JSON.stringify({ day, board }),
  }),
}
